import './AIModal.css';
import { CloseOutlined } from "@material-ui/icons";

export function AIModal({ children, onClose, className }) {
  return (
    <div className="ai-overlay">
      <div className="ai-modal full-screen">
        <div className={`ai-iframe-wrapper ${className}`}>{children}</div>
      </div>
      <button className="ai-close-btn" onClick={onClose}>
        <CloseOutlined />
      </button>
    </div>
  );
}
